import { render } from "./AppNavigationHeader.vue?vue&type=template&id=d8d9dea8"
import script from "./AppNavigationHeader.vue?vue&type=script&lang=js"
export * from "./AppNavigationHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__